import React from 'react'

export const DeleteIcon: React.FC = () => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" width="32" height="32">
    <defs>
      <path
        id="delete_icon_a"
        d="M16.582 6.75l1.283-1.282a.4545.4545 0 000-.642l-.641-.641a.4545.4545 0 00-.642 0L15.3 5.468l-1.283-1.283a.452.452 0 00-.64 0l-.642.641a.4545.4545 0 000 .642l1.283 1.282-1.283 1.283a.452.452 0 000 .64l.641.642c.177.177.464.177.642 0L15.3 8.033l1.282 1.282c.178.177.465.177.642 0l.641-.641a.4533.4533 0 000-.641L16.583 6.75zM6.3 7.2c1.988 0 3.6-1.612 3.6-3.6S8.288 0 6.3 0 2.7 1.612 2.7 3.6s1.612 3.6 3.6 3.6zm2.52.9h-.47c-.624.287-1.319.45-2.05.45-.731 0-1.423-.163-2.05-.45h-.47C1.693 8.1 0 9.793 0 11.88v1.17c0 .745.605 1.35 1.35 1.35h9.9c.745 0 1.35-.605 1.35-1.35v-1.17c0-2.087-1.693-3.78-3.78-3.78z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h32v32H0z" />
      <g transform="translate(7 9)">
        <mask id="delete_icon_b" fill="#fff">
          <use xlinkHref="#delete_icon_a" />
        </mask>
        <g fill="#9A8B88" fillRule="nonzero" mask="url(#delete_icon_b)">
          <path d="M-1.8-3.6h21.6V18H-1.8z" />
        </g>
      </g>
    </g>
  </svg>
)
